export default {
    shared: {
        storedPlaceholder: 'Stored; type to replace',
    },
    // Sub-tabs of the website's Module settings tab.
    tabs: {
        checkout: 'Checkout',
        invoices: 'Invoices',
        customer: 'Customer',
        vehicleLookup: 'Vehicle lookup',
        vehicleStock: 'Vehicle stock',
    },
    modules: {
        introSuper: 'Enable optional features for this website. A module stays inactive until all its dependencies are also on.',
        intro: 'Modules enabled for this website. Contact us to add more.',
        partlyOnNote: 'Partly on, the parts below say which.',
        partlyOn: 'Partly on',
        alsoEnables: 'Turning this on also enables {modules}.',
        requires: 'requires {modules}',
        inactiveDeps: 'Inactive, turn on {modules} first.',
        countOn: '{on} of {total} on',
        categories: {
            content: 'Content',
            customers: 'Customers',
            webshop: 'Commerce',
            pricing: 'Pricing',
            delivery: 'Delivery',
            shopMail: 'Customer emails',
            accounting: 'Accounting',
            channels: 'Sales channels',
            marketing: 'Marketing',
            vehicles: 'Vehicles',
            other: 'Other',
        },
        // Keyed by module id as the registry sends it. Brand names (google,
        // meta, bol) are left out: the server's label is shown as is.
        names: {
            abandoned_cart: 'Abandoned cart emails',
            blog: 'Blog',
            cart: 'Shopping cart',
            catalog: 'Product catalog',
            catalog_discount: 'Catalog & volume discounts',
            checkout: 'Checkout',
            customer: 'Customer accounts',
            delivery_slot: 'Delivery moments',
            discount: 'Discounts',
            faq: 'FAQ',
            giftcard: 'Gift cards',
            landingpages: 'Landing pages',
            newsletter: 'Newsletter',
            portfolio: 'Portfolio',
            review_request: 'Review requests',
            seo: 'SEO',
            shipping: 'Shipping & carriers',
            tax: 'VAT engine',
            vehicle_lookup: 'Vehicle lookup',
            vehicle_stock: 'Vehicle stock',
        },
        // Keyed by group id (cms-core ModuleGroup).
        groups: {
            ecommerce: {
                label: 'Webshop',
                description: 'Product catalog, cart and checkout.',
            },
            discounts: {
                label: 'Discounts',
                description: 'Voucher codes at checkout, gift cards sold in the shop, and automatic sale or volume pricing in the catalog.',
            },
        },
    },
    google: {
        analytics: {
            title: 'Google Analytics and Tag Manager',
            intro: "Loaded on every page, only after the visitor allows it on the cookie banner: Analytics needs statistics consent, Tag Manager either kind, and Google's Consent Mode tells the tags which was given. The shop's e-commerce events (product views, cart, checkout, purchase) go to both.",
            ga4: 'GA4 measurement ID',
            gtm: 'Tag Manager container ID',
            oneOfTwo: 'Fill in one of the two. With Tag Manager, set up GA4 inside the container instead of here, or every visit is counted twice.',
        },
        server: {
            title: 'Purchases sent from the server',
            intro: 'A payment that settles after the customer left (a bank transfer still pending, a closed tab) never shows them the thank-you page, so the tags never see the purchase. With an API secret, the shop sends those purchases to GA4 itself, ten minutes after the payment, for visitors who allowed statistics cookies. GA4 counts each order once, from the page or from the server. Needs the GA4 measurement ID above.',
            apiSecret: 'Measurement Protocol API secret',
            apiSecretPlaceholder: 'GA4 Admin, Data streams, your stream, Measurement Protocol API secrets',
            removeSecret: 'Remove the stored secret',
        },
        verification: {
            title: 'Site verification',
            intro: 'Proves to Google Search Console and Bing Webmaster Tools that this site is yours. Choose the HTML tag method there and paste the code, or the whole {tag} tag. It is added to every page; it sets no cookie, so it needs no consent.',
        },
        feed: {
            title: 'Merchant Center product feed',
            intro: 'Add a feed in Google Merchant Center (Products, Add products from a file, scheduled fetch) with the URL for each language you sell in. It lists every published product with a picture and a price, at the price the shop shows, with brand, barcode and shipping. Gift cards are left out.',
            moduleOff: 'The feed answers once the Google module is switched on.',
        },
        save: 'Save Google settings',
    },
    invoices: {
        intro: 'How invoices and credit notes are numbered, what they say, how they look, and whether they are created and emailed by themselves. The texts, bank details and due date are copied onto an invoice when it is created, so a change here never alters an invoice already issued.',
        checkoutOff: 'Invoices start once the checkout module is on.',
        wholeDays: 'Enter a whole number of days, or leave it empty.',
        wholeNumber: 'Enter a whole number of 1 or more.',
        numbering: {
            title: 'Numbering',
            format: 'Number format',
            reset: 'Counter starts again',
            resets: {
                monthly: 'Every month',
                yearly: 'Every year',
                never: 'Never',
            },
            tokens: 'Placeholders:',
            tokensHelp: 'YYYY and YY are the year, MM the month, N the running number (NNNN pads it to four digits). Letters, digits and . _ / - are copied as they are.',
            nextNumber: 'Next running number',
            nextNumberHint: 'For the current {period}. It only goes up: a number already issued is never issued again.',
            periods: {
                monthly: 'month',
                yearly: 'year',
                never: 'series',
            },
            nextInvoice: 'The next invoice gets number',
            shared: 'Credit notes are numbered in the same series.',
        },
        payment: {
            title: 'Payment',
            term: 'Payment term in days',
            termHint: 'An invoice for an order not paid yet (cash on delivery, or invoiced before the money is in) shows a due date this many days after the invoice date. Empty: no due date.',
            holder: 'Account holder',
            iban: 'IBAN',
            bic: 'BIC',
            bankHint: 'Printed on every invoice, with the payment instruction.',
        },
        texts: {
            title: 'Texts on the invoice',
            intro: 'Above the lines',
            payment: 'Payment instruction',
            paymentHint: 'Only on an invoice not paid yet. Empty: with a payment term, a standard line asks to pay the total by the due date, quoting the invoice number.',
            footer: 'At the bottom',
            placeholders: 'Placeholders:',
            fallback: 'A text left empty in a language uses the {locale} one.',
        },
        look: {
            title: 'Look',
            logo: 'Logo',
            noLogo: 'No logo',
            chooseLogo: 'Choose logo',
            changeLogo: 'Change',
            removeLogo: 'Remove',
            logoTypes: 'A PNG, JPEG or GIF from the media library.',
            logoOtherWebsite: 'Switch to this website to pick its logo from the media library.',
            logoWrongType: 'The logo must be a PNG, JPEG or GIF image.',
            logoSize: 'Logo size',
            sizes: {
                small: 'Small',
                medium: 'Medium',
                large: 'Large',
            },
            accent: 'Accent colour',
            accentHint: 'The title, the lines under the headings and the total.',
            font: 'Font',
            fonts: {
                sans: 'Sans-serif',
                serif: 'Serif',
                mono: 'Monospace',
            },
        },
        when: {
            title: 'Creating and sending',
            createOn: 'Create the invoice',
            create: {
                manual: 'By hand, from the order',
                paid: 'When the order is paid',
                shipped: 'When the order is shipped',
            },
            createHint: 'Cash on delivery counts as paid once the payment is recorded.',
            creditNoteOn: 'Create the credit note',
            credit: {
                manual: 'By hand, from the order',
                refunded: 'When the order is refunded',
            },
            sendOn: 'Email it to the customer',
            send: {
                manual: 'By hand, from the order',
                created: 'As soon as it is created automatically',
                shipped: 'When the order is shipped',
            },
            sendHint: 'An invoice created by hand still waits for Send invoice. A credit note created automatically is emailed straight away when sending is automatic. bol.com orders are never emailed: bol informs its buyers.',
            fromNow: 'Only orders paid, shipped or refunded from now on are handled; earlier orders are left as they are.',
            noMailFrom: 'This website has no mail-from address, so invoices cannot be emailed. Set one in the checkout settings first.',
        },
        preview: 'Preview',
        previewIn: 'Preview in',
        save: 'Save invoice settings',
    },
    meta: {
        intro: 'Loaded on every page only after the visitor allows marketing cookies: PageView everywhere, Purchase on the thank-you page. With the access token, every paid order placed with marketing consent is also sent from the server (Conversions API), with the same event id, so Meta counts it once.',
        moduleOff: 'It runs once the Meta Pixel module is switched on.',
        pixelId: 'Pixel ID',
        token: 'Conversions API access token',
        tokenPlaceholder: 'From Events Manager, Settings, Conversions API',
        removeToken: 'Remove the stored token',
        testCode: 'Test event code',
        testCodeNote: "While set, server events go to Events Manager's Test events tab only. Clear it to go live.",
        sendTest: 'Send test event',
        testReceived: 'Meta received no test events. | Meta received {n} test event. It shows in Events Manager under Test events. | Meta received {n} test events. They show in Events Manager under Test events.',
        save: 'Save Meta settings',
    },
};
